import React from "react";
import styled from "styled-components";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { DropdownContent } from "@sonder/ui/source/styled/components/DropdownContent";
import { PlainButton } from "@sonder/ui/source/styled/fragments/PlainButton";
import { DropdownContentAlignment } from "@sonder/ui/source/styled/surfaces/DropdownContent";
import { useSegment } from "analytics/segment";
import { useUpdateTask } from "core/queries/UpdateTask";
import { PRIORITY_ITEMS, PriorityBadge } from "tasks/components/PriorityBadge";

const TaskPriorityDropdownContent = styled(DropdownContent)`
  flex-direction: column;
  width: 3rem;
  button {
    padding: 0.3rem;
  }
`;
interface TaskPriorityProps {
  alignContent?: DropdownContentAlignment;
  className?: string;
  eventName: string;
  onSetPriority?(value: number | null): void;
  priority: number | null;
  taskId: string;
  trigger?: JSX.Element;
}

export const TaskPriority = ({
  alignContent = "center",
  className,
  priority,
  eventName,
  taskId,
  onSetPriority,
  trigger = (
    <PlainButton onClick={e => e.stopPropagation()}>
      <PriorityBadge priority={priority} />
    </PlainButton>
  ),
}: TaskPriorityProps) => {
  const { track } = useSegment();
  const [onUpdateTask] = useUpdateTask({
    refetchQueries: ["GetTasks"],
  });

  return (
    <Dropdown
      className={className}
      trigger={trigger}
      onClose={() =>
        track({
          eventName,
          action: "click",
          element: "priority_selector.dropdown_trigger",
          props: { nextValue: "closed", taskId },
        })
      }
      onOpen={() =>
        track({
          eventName,
          action: "click",
          element: "priority_selector.dropdown_trigger",
          props: { nextValue: "opened", taskId },
        })
      }
    >
      {({ isOpen, closePortal }) =>
        isOpen && (
          <TaskPriorityDropdownContent
            align={alignContent}
            data-testid="priority-dropdown-content"
          >
            {PRIORITY_ITEMS.map(({ content, value }) => (
              <PlainButton
                data-testid="priority-dropdown-item"
                key={content}
                onClick={() => {
                  closePortal();
                  if (onSetPriority) onSetPriority(value);
                  else
                    onUpdateTask({
                      variables: {
                        taskId,
                        priority: value,
                      },
                    });

                  track({
                    eventName,
                    action: "click",
                    element: "priority_selector.priority_button",
                    props: { priority: content, taskId },
                  });
                }}
              >
                <PriorityBadge priority={value} />
              </PlainButton>
            ))}
          </TaskPriorityDropdownContent>
        )
      }
    </Dropdown>
  );
};
